import {
  Entity,
  PrimaryColumn,
  Column,
  BaseEntity,
  ManyToOne,
  JoinColumn,
} from 'typeorm'
import { Contact as TContactData } from '@/api/client'
import { Project } from './Project'

@Entity('contacts')
export class Contact extends BaseEntity {
  /*
      Contacts are deleted (cascade) when the related project is deleted
    */
  @PrimaryColumn('int')
  id!: number

  @Column('varchar', { nullable: true })
  name!: string | null

  @Column('varchar', { nullable: true })
  saluation!: string | null

  @Column({ type: 'varchar', nullable: true })
  function!: string | null

  @Column({ type: 'varchar', nullable: true })
  phone!: string | null

  @Column({ type: 'varchar', nullable: true })
  email!: string | null

  @Column({ type: 'varchar', nullable: true })
  note!: string | null

  @Column({ type: 'varchar', nullable: true })
  picture_url!: string | null

  @ManyToOne(() => Project, (project) => project.contacts)
  @JoinColumn({ name: 'project_id' })
  project!: Project

  public static createFromData(
    contactData: TContactData,
    project: Project,
  ): Contact {
    const contact = new Contact()
    contact.id = contactData.id
    contact.name = contactData.name
    contact.saluation = contactData.saluation
    contact.function = contactData.function
    contact.phone = contactData.phone
    contact.email = contactData.email
    contact.note = contactData.note
    contact.project = project
    contact.picture_url = contactData.picture_url
    return contact
  }
}
